import { Service } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { getYearPrefixedWithJahrhundert, isSchaltjahr } from '@mng/mng-ts-helpers';

@Service()
export class MngGermanDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    // Handle null, undefined, or empty string - these are valid "no value" states
    if (value === null || value === undefined || value.trim() === '') {
      return null;
    }
    // Try to parse the date
    const trimmedValue = value.trim();
    const result = parseDateInput(trimmedValue);

    // If parsing failed, return an invalid date to trigger matDatepickerParse error
    // Returning null means "no value" (valid), but invalid date means "parse error"
    if (result === null) {
      return this.invalid();
    }

    return result;
  }
}

export function parseDateInput(value: any): Date | null {
  let dateStrings: string[] = [];

  if (value.indexOf('.') !== -1) {
    if (value.length >= 8 && value.length <= 10) {
      dateStrings = value.split('.');

      if (!dateStrings[0] || dateStrings[0].length === 0 || dateStrings[0].length > 2) {
        return null;
      }

      if (!dateStrings[1] || dateStrings[1].length === 0 || dateStrings[1].length > 2) {
        return null;
      }

      if (!dateStrings[2] || dateStrings[2].length < 4 || dateStrings[2].length > 4) {
        return null;
      }
    } else {
      return null;
    }
  } else {
    if (value.length === 8) {
      dateStrings.push(value.substr(0, 2));
      dateStrings.push(value.substr(2, 2));
      dateStrings.push(value.substr(4, 4));
    } else if (value.length === 6) {
      if (value.substr(4, 2) === '19' || value.substr(4, 2) === '20') {
        return null;
      }
      dateStrings.push(value.substr(0, 2));
      dateStrings.push(value.substr(2, 2));
      dateStrings.push(getYearPrefixedWithJahrhundert(value.substr(4, 2)));
    } else {
      return null;
    }
  }

  if (dateStrings.length < 2 || isNaN(+dateStrings[0]) || isNaN(+dateStrings[1]) || isNaN(+dateStrings[2])) {
    return null;
  }

  const day = Number(dateStrings[0]);
  const month = Number(dateStrings[1]);
  const year = Number(dateStrings[2]);

  if (month < 8) {
    if ((!isGerade(month) && day > 31) || (isGerade(month) && day > 30)) {
      return null;
    }
    if (month === 2 && ((isSchaltjahr(year) && day > 29) || (!isSchaltjahr(year) && day > 28))) {
      return null;
    }
  } else if (month >= 8 && month < 13) {
    if ((isGerade(month) && day > 31) || (!isGerade(month) && day > 30)) {
      return null;
    }
  } else {
    return null;
  }

  return new Date(Number(dateStrings[2]), Number(dateStrings[1]) - 1, Number(dateStrings[0]));
}

function isGerade(n) {
  return n % 2 === 0;
}
